import { render, staticRenderFns } from "./OfferToSellTax.vue?vue&type=template&id=1a5adea2&scoped=true"
import script from "./OfferToSellTax.vue?vue&type=script&lang=js"
export * from "./OfferToSellTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5adea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5adea2')) {
      api.createRecord('1a5adea2', component.options)
    } else {
      api.reload('1a5adea2', component.options)
    }
    module.hot.accept("./OfferToSellTax.vue?vue&type=template&id=1a5adea2&scoped=true", function () {
      api.rerender('1a5adea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/islamicFinance/offerToSell/OfferToSellTax.vue"
export default component.exports